<div class="role-container" fxLayout="row" fxLayoutAlign="start" *ngFor="let role of roles">
  <mat-checkbox [disabled]="!appStatus" class="role-checkbox" [checked]="role.status"
    (change)="roleChecked($event, role)">
  </mat-checkbox>
  <span fxFlex="35">{{role.name}}</span>
  <div fxFlex="60" fxLayout="column" fxLayoutAlign="center">
    <span class="role-description">{{role.description}}</span>
  </div>
</div>